import { DatePipe } from '@angular/common';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ProgramTypesGUID } from '../../../models/_enum-collections';
import { BlobFileDownloadRequestModel } from '../../../models/blob-file-sas-url.model';
import {
  DownloadCSV,
  AllEventMilestone2Data,
  ProgramPaymentFeed
} from '../../../models/download-csv.model';
import { ExportService } from '../../services/export.service';
import { CommonSharedModule } from '../../common/shared.module';
import { EventDownloadCSVService } from '../../services/event-download-csv.service';

@Component({
  selector: 'app-export-all-engagement',
  templateUrl: './export-all-engagement.component.html',
  styleUrls: ['./export-all-engagement.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class ExportAllEngagementComponent implements OnInit {
  isLoading = false;
  downloadCSVList!: DownloadCSV[];
  loadingIcon = 'fa-circle-o-notch';
  selectedItem!: DownloadCSV;
  cols!: any[];
  m2Cols: any = [];
  dateFormat = 'MM/dd/yyyy';
  rowCount = 24;
  alleventsmilestone2Data!: AllEventMilestone2Data[];
  programPaymentFeedData!: ProgramPaymentFeed[];

  constructor(
    private eventDownloadCsvService: EventDownloadCSVService,
    private exportService: ExportService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.isLoading = true;
    const csvList = this.eventDownloadCsvService.getDownloadCSVFilesList(
      ProgramTypesGUID.MRPP
    );
    const milestone2Data =
      this.eventDownloadCsvService.getAllEngagementsMilestone2Data();

    forkJoin([csvList, milestone2Data]).subscribe(results => {
      this.downloadCSVList = results[0];
      this.programPaymentFeedData = results[1];
      this.isLoading = false;
      this.changeDetectorRef.markForCheck();
    });

    this.m2Cols = [
      {
        field: 'eventRegistrationId',
        header: 'Engagement Id',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'paymentLineItemId',
        header: 'Line Item ID',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'eventName',
        header: 'Engagement Name',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'categoryName',
        header: 'Category Name',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'countryName',
        header: 'Country Name',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'marketName',
        header: 'Market Name',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'customerName',
        header: 'Customer Name',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'customerCountry',
        header: 'Customer Country',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'tenantId',
        header: 'Tenant Id',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'tpid',
        header: 'TPID',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'requestDate',
        header: 'Request Date',
        isDateFormat: true,
        calculatedValueHTML: false
      },
      {
        field: 'fiscalYear',
        header: 'Fiscal Year',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'dateSubmittedPST',
        header: 'Date Submitted PST',
        isDateFormat: true,
        calculatedValueHTML: false
      },
      {
        field: 'engagementStatus',
        header: 'Engagement Status',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'partnerOneId',
        header: 'Partner One Id',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'partnerLocation',
        header: 'Partner Location',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'pmoConfirmedPartnerID',
        header: 'PMO Confirmed Partner ID',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'pmoConfirmedPartnerName',
        header: 'PMO Confirmed Partner Name',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'payeeID',
        header: 'Payee ID',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'payeeName',
        header: 'Payee Name',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'workshopCompletionDate',
        header: 'Workshop Completion Date',
        isDateFormat: true,
        calculatedValueHTML: false
      },
      {
        field: 'poeCompletionDate',
        header: 'POE Completion Date',
        isDateFormat: true,
        calculatedValueHTML: false
      },
      {
        field: 'pmoNextStepName',
        header: 'PMO Next Step Name',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'l1InternalStatusName',
        header: 'L1InternalStatusName',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'l2InternalStatusName',
        header: 'L2InternalStatusName',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'payoutMetric',
        header: 'Payout Metric',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'payout',
        header: 'Growth Incremental License/Mad ( payout)',
        isDateFormat: false,
        calculatedValueHTML: true
      },
      {
        field: 'm2CategoryTypeValue',
        header: 'M2CategoryTypeValue',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'paymentStatus',
        header: 'Payment Status',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'milestone2PaymentAmount',
        header: 'Milestone2 Payment Amount(Total payment Eligible)',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'paidDate',
        header: 'Milestone2 Paid Date',
        isDateFormat: true,
        calculatedValueHTML: false
      },
      {
        field: 'paymentDocumentNumber',
        header: 'Payment Doc Number',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'invoiceNumber',
        header: 'Milestone2 Invoice Number',
        isDateFormat: false,
        calculatedValueHTML: false
      },
      {
        field: 'paymentCentralTransactionId',
        header: 'Milestone2 Payment Central Transaction ID',
        isDateFormat: false,
        calculatedValueHTML: false
      }
    ];
  }

  payeeIdPaymentReport(haspayeeId: boolean) {
    this.eventDownloadCsvService
      .exportMRPPPayeePaymentReport(haspayeeId)
      .subscribe(exceldata => {
        if (exceldata.length > 0) {
          const docname =
            haspayeeId == true
              ? 'MRPP_Ready For Payment'
              : 'MRPP_No Payee Id Ready For Payment';
          this.exportService.exportExcel(exceldata, docname);
        }
      });
  }

  exportNoPayeeIDPaymentReport() {
    this.payeeIdPaymentReport(false);
  }

  exportReadyforPaymentReport() {
    this.payeeIdPaymentReport(true);
  }

  downloadFile(selectedFile: DownloadCSV) {
    const blobFileDownloadRequestModel: BlobFileDownloadRequestModel = {
      fileName: selectedFile.fileName || '',
      fileUrl: selectedFile.url || ''
    };

    this.eventDownloadCsvService
      .downloadCSVFile(blobFileDownloadRequestModel)
      .subscribe(downloadFileSasUrl => {
        window.location.href = downloadFileSasUrl;
      });
  }

  getCalculatedValue(rowData: any, column: any, isExcelDownload = false) {
    if (column !== 'payout') return '';

    const { growthIncrementalLicenses, madPayout } = rowData;
    const result =
      `${growthIncrementalLicenses}/${madPayout}` +
      (growthIncrementalLicenses !== madPayout
        ? (isExcelDownload ? '' : '<br/>') +
          (growthIncrementalLicenses > madPayout
            ? ` Earned Licenses ${growthIncrementalLicenses}`
            : ` Earned MAD ${madPayout}`)
        : '');

    return result;
  }

  exportAllEngagementsMilestone2() {
    const dp = new DatePipe('en-US');
    const docname = 'All Engagements Milestone 2';
    if (this.programPaymentFeedData.length > 0) {
      const formattedData = this.programPaymentFeedData.map(item => {
        return this.m2Cols.reduce((formattedItem, column) => {
          formattedItem[column.header] = column.isDateFormat
            ? dp.transform(item[column.field], this.dateFormat)
            : column.calculatedValueHTML
              ? this.getCalculatedValue(item, column.field, true)
              : item[column.field];
          return formattedItem;
        }, {});
      });
      this.exportService.exportToCsv(formattedData, docname);
    }
  }
}
